import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api/api";

export default function History() {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [filter, setFilter] = useState("All"); // all | active | completed

  /* ================= DATE FORMAT ================= */
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const weekday = date.toLocaleDateString("en-GB", {
      weekday: "long"
    });

    const day = String(date.getDate()).padStart(2, "0");

    const month = date.toLocaleDateString("en-GB", {
      month: "long"
    });

    const year = date.getFullYear();

    const time = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    });

    return `${weekday}, ${day} ${month} ${year} • ${time}`;
  };

  /* ================= LOAD HISTORY ================= */
  useEffect(() => {
    API.get("/coordinator/history")
      .then(res => setHistory(Array.isArray(res.data) ? res.data : []))
      .catch(err => console.error("history error:", err));
  }, []);

  /* ================= STATUS ================= */
  const getStatus = (h) => {

    const now = new Date();

    const endTime = new Date(
        h.end_datetime || h.start_datetime
    );


    if (
        h.unassigned_at ||
        endTime < now
    ) {
        return "Completed";
    }


    return "Active";
};

  /* ================= FILTERED DATA ================= */
  const filteredHistory = useMemo(() => {
    if (filter === "All") return history;
    return history.filter(h => getStatus(h) === filter);
  }, [history, filter]);

  return (
    <div style={page}>

      {/* HEADER */}
      <div style={header}>
        <h2 style={title}>Tour History</h2>
        <p style={subtext}>Your completed and active coordinator tour sessions</p>
      </div>

      {/* FILTER */}
      <div style={filterRow}>
        {["All", "Active", "Completed"].map(type => (
          <button
            key={type}
            onClick={() => setFilter(type)}
            style={{
              ...filterBtn,
              background:
                filter === type ? "#0ea5e9" : "#f1f5f9",
              color: filter === type ? "white" : "#0f172a"
            }}
          >
            {type}
          </button>
        ))}
      </div>

      {/* LIST */}
      {filteredHistory.length === 0 ? (
        <div style={emptyState}>
          <p>No history found</p>
        </div>
      ) : (
        <div style={grid}>
          {filteredHistory.map(h => {
            const status = getStatus(h);

            return (
              <div
                key={h.id}
                style={card}
                onClick={() => navigate(`/coordinator/tour/${h.tour_session_id}`)}
              >

                {/* TOP */}
                <div style={topRow}>
                  <h4 style={tourTitle}>{h.tour_title}</h4>

                  <span
                    style={{
                      ...badge,
                      background:
                        status === "Completed"
                          ? "#22c55e"
                          : "#f59e0b"
                    }}
                  >
                    {status}
                  </span>
                </div>

                {/* INFO */}
                <div style={info}>
                  <p>
                    📅 Start: {formatDateTime(h.start_datetime)}
                  </p>

                  <p>
                    📌 Assigned: {formatDateTime(h.assigned_at)}
                  </p>

                  <p>
    
                      🏁 Finished:{" "}
                      {h.unassigned_at
                          ? formatDateTime(h.unassigned_at)
                          : getStatus(h) === "Completed"
                              ? formatDateTime(h.end_datetime)
                              : "Still Active"}
                  </p>
                </div>

                <div style={divider} />

                <p style={footerText}>
                  Session #{h.tour_session_id}
                </p>

              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

/* ================= STYLES ================= */

const page = {
  padding: 24,
  background: "#f8fafc",
  minHeight: "100vh",
  
};

const header = {
  marginBottom: 16
};

const title = {
  margin: 0,
  fontSize: 22,
  fontWeight: 600,
  color: "#0f172a"
};

const subtext = {
  marginTop: 6,
  fontSize: 13,
  color: "#64748b"
};

/* FILTER */
const filterRow = {
  display: "flex",
  gap: 10,
  marginBottom: 18
};

const filterBtn = {
  padding: "7px 12px",
  borderRadius: 10,
  border: "1px solid #e2e8f0",
  cursor: "pointer",
  fontSize: 13
};

/* GRID */
const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
  gap: 16
};

const card = {
  background: "white",
  borderRadius: 14,
  padding: 16,
  border: "1px solid #e2e8f0",
  boxShadow: "0 6px 20px rgba(15,23,42,0.05)",
  cursor: "pointer"
};

const topRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 10
};

const tourTitle = {
  margin: 0,
  fontSize: 15,
  fontWeight: 600,
  color: "#0f172a"
};

const badge = {
  color: "white",
  fontSize: 11,
  padding: "4px 8px",
  borderRadius: 20
};

const info = {
  fontSize: 13,
  color: "#334155",
  lineHeight: 1.7
};

const divider = {
  marginTop: 10,
  height: 1,
  background: "#f1f5f9"
};

const footerText = {
  marginTop: 8,
  fontSize: 11,
  color: "#94a3b8"
};

const emptyState = {
  padding: 20,
  background: "white",
  borderRadius: 12,
  border: "1px solid #e2e8f0"
};